export interface NewsItem {
  id: string;
  title: string;
  category: string;
  date: string;
  summary: string;
  image: string;
  readTime: string;
}

// 演示资讯数据，仅用于前端展示
export const newsList: NewsItem[] = [
  {
    id: "news-01",
    title: "《长夜之光》定档跨年，导演称“这是一部关于等待的电影”",
    category: "上映动态",
    date: "10 月 16 日",
    summary:
      "影片以一场全城停电为起点，讲述普通人在黑夜里选择成为光的故事。导演沈墨川在发布会上表示，剧组为了拍好夜戏，坚持使用了超过 80% 的实景照明。",
    image:
      "https://readdy.ai/api/search-image?query=film%20press%20conference%20stage%20with%20deep%20navy%20backdrop%20and%20warm%20amber%20spotlight%20on%20an%20empty%20director%20chair%20cinematic%20minimal%20no%20text&width=640&height=420&seq=news-01&orientation=landscape",
    readTime: "3 分钟",
  },
  {
    id: "news-02",
    title: "本周剧集热度榜：《奕夜海图》连续三周登顶",
    category: "热度榜单",
    date: "10 月 15 日",
    summary:
      "悬疑剧《奕夜海图》凭借双线叙事与扎实的档案细节，在观众讨论度与完播率上双双领先。《春山记》则是古装赛道里口碑最稳的一部。",
    image:
      "https://readdy.ai/api/search-image?query=film%20festival%20stage%20with%20warm%20amber%20spotlights%20against%20deep%20navy%20velvet%20curtains%20and%20silhouettes%20of%20an%20audience%20cinematic%20no%20text&width=640&height=420&seq=news-02&orientation=landscape",
    readTime: "4 分钟",
  },
  {
    id: "news-03",
    title: "从《老街的面包房》看治愈系电影的“慢”哲学",
    category: "深度观察",
    date: "10 月 13 日",
    summary:
      "没有强情节，也没有反转，一部关于面包房的电影却让许多观众二刷。我们和三位影评人聊了聊，为什么“慢”正在成为一种稀缺的观影体验。",
    image:
      "https://readdy.ai/api/search-image?query=artisanal%20bread%20and%20dough%20on%20a%20floured%20wooden%20table%20in%20warm%20amber%20morning%20light%20deep%20teal%20shadow%20editorial%20food%20photography%20no%20text&width=640&height=420&seq=news-03&orientation=landscape",
    readTime: "6 分钟",
  },
  {
    id: "news-04",
    title: "《山海拾者》幕后：那些真实存在的山与海",
    category: "幕后故事",
    date: "10 月 11 日",
    summary:
      "剧组历时十一个月，走过六个省份的取景地。美术指导分享了如何在真实山水之间，把奇幻想象安放得恰到好处。",
    image:
      "https://readdy.ai/api/search-image?query=film%20crew%20silhouettes%20filming%20on%20misty%20mountain%20ridge%20at%20dawn%20with%20camera%20tripod%20deep%20blue%20fog%20warm%20amber%20sunrise%20cinematic%20no%20text&width=640&height=420&seq=news-04&orientation=landscape",
    readTime: "5 分钟",
  },
  {
    id: "news-05",
    title: "冷门佳片清单：五部值得重新发现的小成本电影",
    category: "片单推荐",
    date: "10 月 09 日",
    summary:
      "预算不高，但每一部都在某个瞬间打动过人。本期片单从爱情、家庭到西部题材，帮你在热门之外，找到另一种观看的可能。",
    image:
      "https://readdy.ai/api/search-image?query=stack%20of%20vintage%20film%20reels%20and%20cinema%20tickets%20on%20a%20dark%20wood%20table%20with%20warm%20amber%20lamp%20light%20deep%20navy%20shadows%20no%20text&width=640&height=420&seq=news-05&orientation=landscape",
    readTime: "7 分钟",
  },
  {
    id: "news-06",
    title: "秋季新剧前瞻：科幻与现实主义同台竞技",
    category: "定档速览",
    date: "10 月 07 日",
    summary:
      "接下来一个月里，多部新剧集中上线。我们整理了值得留意的作品与看点，帮你提前规划追剧日历。",
    image:
      "https://readdy.ai/api/search-image?query=modern%20cinema%20lobby%20with%20retro%20poster%20light%20boxes%20and%20warm%20amber%20glow%20deep%20navy%20walls%20cinematic%20wide%20no%20text&width=640&height=420&seq=news-06&orientation=landscape",
    readTime: "4 分钟",
  },
];